import { render, staticRenderFns } from "./CablesFlatRoof.vue?vue&type=template&id=2f6b3d1c&scoped=true"
import script from "./CablesFlatRoof.vue?vue&type=script&lang=js"
export * from "./CablesFlatRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b3d1c",
  null
  
)

export default component.exports